import { render, staticRenderFns } from "./Shouye.vue?vue&type=template&id=0e607f16&scoped=true"
import script from "./Shouye.vue?vue&type=script&lang=js"
export * from "./Shouye.vue?vue&type=script&lang=js"
import style0 from "./Shouye.vue?vue&type=style&index=0&id=0e607f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e607f16",
  null
  
)

export default component.exports